import React, {useEffect} from 'react';
import {FormattedMessage} from 'react-intl';
import {Collapse, Typography} from '@material-ui/core';
import {Alert, AlertTitle} from '@material-ui/lab';

const useAlertTimer = ({isOpen, setOpen}) => {
  useEffect(() => {
    if (isOpen) {
      const timeId = setTimeout(() => {
        setOpen(false)
      }, 3000);
      return () => {
        clearTimeout(timeId)
      }
    }
  }, [isOpen, setOpen]);
};

export default function AlertWithTimer({severity, isOpen, setOpen, children}) {
  useAlertTimer({isOpen, setOpen});
  return (
    <Collapse in={isOpen}>
      <Alert severity={severity} onClose={() => setOpen(false)}>
        {severity === "warning" &&
        <AlertTitle>
          <FormattedMessage defaultMessage="Jotain meni pieleen"/>
        </AlertTitle>}
        <Typography>
          {children}
        </Typography>
      </Alert>
    </Collapse>
  );
}
